import { useQuery } from "react-query";
import { getClassroom } from "../services/school/classroom/classroom";
import { PagedRequestType } from "../types/PagedResults";
import { Key_classroom, key_libraryStats } from "../utils/constants";
import { getLibraryStats } from "../services/library/libraryStats";

export const useGetLibraryStatsQuery = (options:any= null) =>
  useQuery(
    [key_libraryStats],
    () => getLibraryStats(), 
    options?{...options}:{}
  );